import React from "react";
import { NavLink } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userState } from "../../stores/atoms";

function Menu() {
  const [user] = useRecoilState(userState);

  return (
    <div className="menu">
      <ul className="list-unstyled components">
        {user.authorized === 1 &&
          <NavLink
            activeClassName="is-active"
            className="menu-item"
            to="/payment"
          >
            <li>
              결제수단 관리 <i className="fas fa-chevron-right txt-light-gray"></i>
            </li>
          </NavLink>
        }
        {(user.authorized === 1 || user.authorized === 2) && 
        <>
        <NavLink activeClassName="is-active" className="menu-item" to="/group">
          <li>
            그룹 관리<i className="fas fa-chevron-right txt-light-gray"></i>
          </li>
        </NavLink>
        <NavLink
          activeClassName="is-active"
          className="menu-item"
          to="/employee"
        >
          <li>
            직원 관리<i className="fas fa-chevron-right txt-light-gray"></i>
          </li>
        </NavLink>
        </>
        }
        <NavLink
          activeClassName="is-active"
          className="menu-item"
          to="/use-history"
        >
          <li>
            이용 내역<i className="fas fa-chevron-right txt-light-gray"></i>
          </li>
        </NavLink>
        <NavLink
          activeClassName="is-active"
          className="menu-item"
          to="/unpaid-history"
        >
          <li>
            결제실패 내역<i className="fas fa-chevron-right txt-light-gray"></i>
          </li>
        </NavLink>
        {user.authorized === 1 &&
        <NavLink activeClassName="is-active" className="menu-item" to="/admin">
          <li>
            관리자 관리<i className="fas fa-chevron-right txt-light-gray"></i>
          </li>
        </NavLink>
        }
      </ul>
    </div>
  );
}

export default Menu;
